import { useSelector } from "react-redux";

const useTourPackages = () => {
    const tourPackages = useSelector((state) => state.tourPackages);
    return tourPackages;
};

export default useTourPackages;